import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import App from './Components/App/App';
import store from './store';
import registerServiceWorker from './registerServiceWorker';
//import {initApp} from './appInit'


//initApp()
ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
)
registerServiceWorker()





// WEBPACK FOOTER //
// ./src/index.js